import { render } from "./InvoiceStatusReportSuppliers.vue?vue&type=template&id=dd2121aa"
import script from "./InvoiceStatusReportSuppliers.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusReportSuppliers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__